import { AschehougOidcClient, RequestScopes } from '@aschehoug/aschehoug-oidc-client'
import './styles/index.scss'

export const aschehougOidcClient = new AschehougOidcClient({
  authority: import.meta.env.VITE_AM_CORE,
  client_id: import.meta.env.VITE_AM_CLIENT_ID,
  redirect_uri: import.meta.env.VITE_HOST,
  redirect_feide_uri: import.meta.env.VITE_HOST + '/feide',
  scope: RequestScopes.openIdProfile,
  post_logout_redirect_uri: import.meta.env.VITE_HOST,
  response_type: 'code',
  metadata: {
    authorization_endpoint: import.meta.env.VITE_AM_CORE + '/am/oauth2/realms/root/authorize',
  },
  base_uri_am: import.meta.env.VITE_AM_CORE,
  selfService_api_url: import.meta.env.VITE_API_CORE,
  idCloudUrl: import.meta.env.VITE_ID_CLOUD,
  external_api_url: import.meta.env.VITE_CORE_EXTERNAL_API_URL,
  tokenCookieName: import.meta.env.VITE_OIDC_COOKIE_NAME,
  mediaTokenCookieName: import.meta.env.VITE_OIDC_MEDIA_COOKIE_NAME,
  cookieDomain: import.meta.env.VITE_OIDC_COOKIE_DOMAIN,
})
